import { z } from 'zod';
import { RoomStatus } from '../../../shared/types/rooms/RoomStatus';

const RoomSchema = z.object({
    id: z.string(),
    property_id: z.string(),
    room_type_id: z.string(),
    room_number: z.string(),
    status: z.nullable(z.enum(RoomStatus.map((s) => s.value) as [string, ...string[]])).optional(),
    condition: z.nullable(z.string()).optional(),
});

const RatePlanSchema = z.object({
    id: z.string(),
    property_id: z.string(),
    room_type_id: z.string(),
    name: z.string(),
    min_night: z.number(),
    max_night: z.number(),
});

export const RoomTypeSchema = z.object({
    id: z.string(),
    property_id: z.string(),
    name: z.string(),
    occ_adults: z.number(),
    occ_children: z.number(),
    available: z.number(),
    rooms: z.array(RoomSchema).optional(),
    rate_plans: z.array(RatePlanSchema).optional(),
});

export const CheckAviResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(RoomTypeSchema),
});

export type CheckAviResponseType = z.infer<typeof CheckAviResponse>;
export type RoomTypeData = z.infer<typeof RoomTypeSchema>;